import { GoogleMapContainer, MapPlaceholderBlock } from './styled';

export const ItemsMapPlaceholder: React.FC = () => {
  return (
    <GoogleMapContainer>
      <MapPlaceholderBlock width="100%" height="460px" margin="0" />
    </GoogleMapContainer>
  );
};
